import React, { useEffect, useMemo, useState } from "react";
import { Search } from "lucide-react";

import { Input } from "components/ui/input";
import { useBreadcrumbs } from "app/breadcrumb-provider";
import ShipmentInformationReports from "./ShipmentInformationReports";

const REPORT_GRID =
  "grid-cols-[minmax(260px,1.4fr)_minmax(160px,1fr)_300px_220px_150px]";

const reports = [
  {
    id: "shipment-information-report",
    title: "Shipment Information Report",
    category: "Shipments",
    createdBy: "System Generated",
  },
];

const Reports = () => {
  const { setBreadcrumbs, setHeaderBorder } = useBreadcrumbs();
  const [search, setSearch] = useState("");

  useEffect(() => {
    setBreadcrumbs([{ label: "Reports", href: "/reports" }]);
    setHeaderBorder(false);

    return () => setHeaderBorder(true);
  }, [setBreadcrumbs, setHeaderBorder]);

  const filteredReports = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return reports;

    return reports.filter(
      report =>
        report.title.toLowerCase().includes(q) ||
        report.category.toLowerCase().includes(q)
    );
  }, [search]);

  const shipmentReports = filteredReports.filter(
    report => report.category === "Shipments"
  );

  return (
    <div className="min-h-full bg-white">
      <div className="relative overflow-hidden py-8">
        <div className="absolute inset-0 pointer-events-none opacity-40 bg-[radial-gradient(circle_at_20px_20px,#dbeafe_1px,transparent_1px)] [background-size:42px_42px]" />

        <div className="relative w-full px-6 lg:px-10 xl:px-16">
          <h1 className="text-center text-2xl font-semibold text-slate-900">
            Reports Center
          </h1>

          <div className="relative mx-auto mt-4 max-w-xl">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
            <Input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search reports"
              className="h-10 rounded-md border-slate-200 bg-white pl-9 text-sm shadow-sm"
            />
          </div>
        </div>
      </div>

      <div className="w-full px-6 lg:px-10 xl:px-16">
        <div className="w-full overflow-x-auto rounded-lg border border-slate-200 bg-white shadow-sm">
          <div className="min-w-[1150px]">
            <div className="px-4 py-3">
              <h2 className="text-lg font-semibold text-slate-900">
                All Reports
              </h2>
            </div>

            <div
              className={`grid ${REPORT_GRID} border-y border-slate-200 bg-slate-50 px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-500`}
            >
              <div>Report Name</div>
              <div>Created By</div>
              <div>Date Range</div>
              <div>Customer</div>
              <div>Action</div>
            </div>

            {shipmentReports.length > 0 ? (
              shipmentReports.map(report => (
                <div
                  key={report.id}
                  className={`grid ${REPORT_GRID} items-center gap-3 border-b border-slate-200 px-4 py-3 text-left text-sm last:border-b-0`}
                >
                  <div className="font-medium text-black">
                    {report.title}
                  </div>

                  <div className="text-slate-700">
                    {report.createdBy}
                  </div>

                  <ShipmentInformationReports embedded />
                </div>
              ))
            ) : (
              <div className="py-10 text-center text-sm text-slate-500">
                No reports found.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;